import { Box, Button, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import LoadingButton from '@mui/lab/LoadingButton';
import { Modal } from '../../../components/modals/Modal';


type ActiveSessionModalProps = {
  isOpen: boolean;
  isLoading: boolean;
  onClose: () => void;
  onDismissAndSignOut: () => void;
  onConfirmLogin: () => void;
};

export function ActiveSessionModal({
  isOpen,
  isLoading,
  onClose,
  onDismissAndSignOut,
  onConfirmLogin,
}: ActiveSessionModalProps) {
  return (
    <Modal open={Boolean(isOpen)} onClose={onClose}>
      <Modal.Header>
        <Box
          sx={{
            backgroundColor: 'primary.main',
            padding: '5px 10px',
            display: 'flex',
            flexDirection: 'row',
          }}
        >
          <Box sx={{ flex: 1 }}>
            <Typography
              sx={{
                color: '#fff',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              Warning
              <IconButton aria-label="close" onClick={onClose}>
                <CloseIcon sx={{ color: '#fff' }} />
              </IconButton>
            </Typography>
          </Box>
        </Box>
      </Modal.Header>
      <Modal.Body>
        <Typography sx={{ background: '#fff', padding: '5px' }}>
          You have an active login session with another device! <br /> Do you want to log in here? (This will close all
          active sessions)
        </Typography>
      </Modal.Body>
      <Modal.Footer>
        <Box
          sx={{
            background: '#fff',
            display: 'flex',
            justifyContent: 'end',
            gap: '5px',
            padding: '5px',
          }}
        >
          <Button variant="outlined" onClick={onDismissAndSignOut}>
            Close
          </Button>
          <LoadingButton
            loading={isLoading}
            variant="contained"
            onClick={onConfirmLogin}
          >
            Log In
          </LoadingButton>
        </Box>
      </Modal.Footer>
    </Modal>
  );
}
